import { Component, OnInit, Input } from '@angular/core';
import { REWARD_STATUS, MarketplaceItemV2 } from '@fgb/core';
import { CommonModule } from '@angular/common';
import { LoyaltyIconModule } from '@fgb/portal-component-library/src/lib/shared/loyalty-icon';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { RouterModule } from '@angular/router';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { CarouselModule } from 'ngx-owl-carousel-o';

@Component({
  selector: 'fgbcl-marketplace-list-item-v2',
  standalone: true,
  imports: [CommonModule, LoyaltyIconModule, PipesModule, DirectivesModule, RouterModule, CarouselModule, FGBSharedModule],
  templateUrl: './marketplace-list-item-v2.component.html',
  styleUrls: ['./marketplace-list-item-v2.component.scss'],
})
export class MarketplaceListItemV2Component implements OnInit {
  @Input() marketplaceItem: MarketplaceItemV2;
  @Input() ignoreLink: boolean = false;
  @Input() featuredIcon: string = 'star';
  marketplaceStatus = REWARD_STATUS;
  constructor() {}

  ngOnInit(): void {}

  get imageUrl(): string {
    return this.marketplaceItem.ImageURL || (this.marketplaceItem as any).ItemImageURL;
  }
}
